import axios from 'axios';
import { pathfinder } from '@fiverr-private/pathfinder';
import logError from '../../utils';

const SERVER_ERROR = 500;

const generateClientToken = async (paymentOptionId, contextType = null, contextId = null, userId = null) => {
    try {
        const {
            data: { client_token },
        } = await axios.post(pathfinder('generate_paypal_client_token'), {
            payment_option_id: paymentOptionId,
            context_type: contextType,
            context_id: contextId,
            user_id: userId,
        });
        return client_token;
    } catch (error) {
        const {
            response: { data, status },
        } = error;

        if (status === SERVER_ERROR) {
            logError(error, { module: 'generate client token', payload: { response: data } });
        }

        return 'generate client token error';
    }
};

const createBillingAgreement = async (payment_method_nonce, context_type, context_id) => {
    try {
        await axios.post(pathfinder('create_paypal_billing_agreement'), {
            payment_method_nonce,
            context_type,
            context_id,
        });
    } catch (error) {
        const {
            response: { data, status },
        } = error;

        if (status === SERVER_ERROR) {
            logError(error, { module: 'create paypal billing agreement', payload: { response: data } });
        }

        throw 'create billing agreement error';
    }
};

const getBillingAgreement = async (context_type, context_id) => {
    try {
        const {
            data: { email, saved_payment_method_id },
        } = await axios.get(pathfinder('get_paypal_billing_agreement'), { params: { context_type, context_id } });
        return { email, saved_payment_method_id };
    } catch (error) {
        const {
            response: { data, status },
        } = error;

        if (status === SERVER_ERROR) {
            logError(error, { module: 'get paypal billing agreement', payload: { response: data } });
        }

        throw 'no billing agreement found';
    }
};

export { generateClientToken, createBillingAgreement, getBillingAgreement };
